let idx = 1

export function uuid () {
  return Date.now() + '' + (idx++)
}
